import React, { useRef, useEffect } from 'react';
import SectionHeader from '../common/SectionHeader';

import { ReactComponent as BackgroundImage } from '../assets/logo_infinity.svg';
import Skill from './skills/Skill';

import { ReactComponent as MobileAppsImage } from '../assets/skills/mobile_apps_sm.svg';
import { ReactComponent as BackendImage } from '../assets/skills/backend_sm.svg';
import { ReactComponent as GraphicsImage } from '../assets/skills/graphics_sm.svg';
import { ReactComponent as ProjectManagementImage } from '../assets/skills/project_management_sm.svg';
import { useI18n } from '../i18n/I18nContext';
import { routeIds } from '../i18n/routes';

function Skills({decoration}) {
  const { pathFor, t, locale } = useI18n();
  const sectionRef = useRef(null);

  useEffect(() => {
    if (['#expertises', '#expertise'].includes(window.location.hash) && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'instant' });
    }
  }, [locale]);

  const allSkills = [
    <Skill
      image={<MobileAppsImage data-ambient className="skill-art motion-art mx-auto" />}
      title={t("expertise.mobileApps.heading")}
      description={t("expertise.mobileApps.intro")}
      href={pathFor(routeIds.mobileApps)}
      corners="top-left bottom-left bottom-right"
    />,
    <Skill
      image={<BackendImage data-ambient className="skill-art motion-art mx-auto" />}
      title={t("expertise.backend.heading")}
      description={t("expertise.backend.intro")}
      href={pathFor(routeIds.backend)}
      corners="top-left top-right bottom-right"
    />,
    <Skill
      image={<GraphicsImage data-ambient className="skill-art motion-art mx-auto" />}
      title={t("expertise.graphics.heading")}
      description={t("expertise.graphics.intro")}
      href={pathFor(routeIds.graphics)}
      corners="top-left bottom-left bottom-right"
    />,
    <Skill
      image={<ProjectManagementImage data-ambient className="skill-art motion-art mx-auto" />}
      title={t("expertise.projectManagement.heading")}
      description={t("expertise.projectManagement.intro")}
      href={pathFor(routeIds.projectManagement)}
      corners="top-left top-right bottom-right"
    />,
  ];

  return (
    <section id={locale === 'en' ? 'expertise' : 'expertises'} ref={sectionRef} className="relative bg-primary-500/40 overflow-x-clip py-[5rem] px-10 z-20">
      <div className="max-w-[1200px] mx-auto">
        {decoration && <BackgroundImage className="absolute text-white right-[-445px] w-[609px] h-[314px] bottom-0 transform translate-y-1/2" />}
        <SectionHeader title={t("home.skills.title")} subtitle={t("home.skills.subtitle")} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[60px] gap-y-[3.125rem] py-[4.375rem]">
          {allSkills}
        </div>
        <div className="flex justify-center w-full font-bold text-dark pb-[1.625rem]">{t("home.skills.question")}</div>
        <div className="flex justify-center w-full pb-[1.25rem]">
          <a className="motion-button bg-accent text-white font-bold rounded-full uppercase py-[1.25rem] px-[60px] z-30 transition duration-300 hover:opacity-50" href={pathFor(routeIds.contact)}>{t("common.contactUs")}</a>
        </div>
      </div>
    </section>
  );
}

export default Skills;
